import { render } from "./mped-cost-view-component.vue?vue&type=template&id=bb8b6220&scoped=true"
import script from "./mped-cost-view-component.vue?vue&type=script&setup=true&lang=js"
export * from "./mped-cost-view-component.vue?vue&type=script&setup=true&lang=js"

import "./mped-cost-view-component.vue?vue&type=style&index=0&id=bb8b6220&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb8b6220"],['__file',"src/views/mped/components/mped-cost-view-component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bb8b6220"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bb8b6220', __exports__)) {
    api.reload('bb8b6220', __exports__)
  }
  
  module.hot.accept("./mped-cost-view-component.vue?vue&type=template&id=bb8b6220&scoped=true", () => {
    api.rerender('bb8b6220', render)
  })

}


export default __exports__